(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash.merge"), require("@ecomplus/utils"), require("lodash.clonedeep"), require("@ecomplus/client"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash.merge", "@ecomplus/utils", "lodash.clonedeep", "@ecomplus/client"], factory);
	else if(typeof exports === 'object')
		exports["EcomSearch"] = factory(require("lodash.merge"), require("@ecomplus/utils"), require("lodash.clonedeep"), require("@ecomplus/client"));
	else
		root["EcomSearch"] = factory(root["lodash.merge"], root["@ecomplus/utils"], root["lodash.clonedeep"], root["@ecomplus/client"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__32__, __WEBPACK_EXTERNAL_MODULE__33__, __WEBPACK_EXTERNAL_MODULE__85__) {
return 